import { render, staticRenderFns } from "./ContinousFilingBeneficialOwners.vue?vue&type=template&id=13a1c4cb&scoped=true&"
import script from "./ContinousFilingBeneficialOwners.vue?vue&type=script&lang=js&"
export * from "./ContinousFilingBeneficialOwners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a1c4cb",
  null
  
)

export default component.exports